/**
 * Unlike Guides, SelectableGuides are marked unique by the array of guide_ids. This is a simple helper function
 * to quickly identify whether a SelectableGuide.guide_ids array matches a Track.guide_ids array. Coincidentally,
 * NOT sorting + checking .includes() was consistently the fastest average time for large arrays, so that's what
 * I used here, but these will always be small arrays, so if you want do something different, feel free.
 */
export const matchSelectableGuide = (
  arr1: number[] | undefined,
  arr2: number[] | undefined,
) => {
  if (arr1 === arr2) return true;

  if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;

  /** For small arrays, direct comparison is more performant */
  if (arr1.length <= 2) return arr1.every((id) => arr2.includes(id));

  const set = new Set(arr2);
  return arr1.every((id) => set.has(id));
};
